import React, { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';
import moment from "moment";
import {
    SidePanel,
    SidePanelHeader,
    SidePanelBody,
    SidePanelFooter,
    Button,
    Select,
    TimeFrame,
    useTimeFrameComponent
} from '@gpstrackit/gtc-react-controls';

import {
    Grid
} from "@mui/material";

import {
    openAdvancedFilters,
    closeAdvancedFilters
} from '../redux/slice';

const AnswersAdvancedFilters = () => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const answers = useSelector(state => state.dynamicFormsViewAnswersRedux.answers);
    const loading = useSelector(state => state.dynamicFormsViewAnswersRedux.loading);
    const open = useSelector(state => state.dynamicFormsViewAnswersRedux.openAdvancedFilters);

    return (
        <SidePanel
            isOpen={open}
            onToggle={() => {
                if (!open) {
                    dispatch(openAdvancedFilters())
                } else {
                    dispatch(closeAdvancedFilters())
                }
            }}
            style={{ zIndex: 2, width: '400px', transform: 'translateX(400px)' }}
            contentStyle={{ overflowY: "hidden" }}
        >
            <SidePanelHeader>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <h2 style={{ margin: 0 }}>
                            {messages['dynamicFormsViewAnswers_advancedFilters']}
                        </h2>
                    </Grid>
                </Grid>
            </SidePanelHeader>

            <SidePanelBody
                style={{
                    height: "auto"
                }}
            >
                <div>
                    {
                        answers?.dynamicForm?.pages?.map((page, index) => {
                            return (
                                <div key={index} className="view-answers-page-shortcut">
                                    <a href={`#${page.id}`} className="btn-link">
                                        {page.title}
                                    </a>
                                </div>
                            )
                        })
                    }
                </div>
            </SidePanelBody>
        </SidePanel>
    )
};

export default AnswersAdvancedFilters;